import type { IconType } from "@circle-react-shared/Icon";

import type { DropdownLink } from "./types";

interface GetContentProps {
  icon: IconType;
  iconSize: number;
  isVisible: boolean;
  link: string;
  title: string;
}
export const getContent = ({
  isVisible,
  link,
  icon,
  iconSize,
  title,
}: GetContentProps): DropdownLink[] => {
  if (!isVisible) return [];

  return [{ value: title, label: title, pathTo: link, icon, iconSize }];
};
